import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { CustomButton } from '../../components/CustomButton';
import { ReactComponent as Filter } from '../../assets/svgIcons/filter-icon.svg';
import { InputText } from 'primereact/inputtext';
import { useNavigate, useParams } from 'react-router-dom';
import { Dropdown } from 'primereact/dropdown';

import {
  changeAgentFilter,
  changeAgentSearchtUser,
  changeTicketStatusFilter,
} from '../../reducers/wca/sales-support/sales-support-slice';
import modulesName from '../../roles/modulesName';
import permissions from '../../roles/permissions';
import { API_GET_ALL_AGENTS } from '../../api/account.service';
import ToggleCard from '../../components/ToggelCad/Index';

const Search = () => {
  const [username, setUsername] = useState('');
  const [err, setErr] = useState(false);
  const [initialLoad, setInitialLoad] = useState(true);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { mob } = useParams();
  useEffect(() => {
    const debouncedSearch = setTimeout(() => {
      dispatch(changeAgentSearchtUser(username));
    }, 1000);
    return () => {
      clearTimeout(debouncedSearch);
    };
  }, [username]);

  useEffect(() => {
    if (mob && mob?.length > 4) {
      setUsername(mob);
      dispatch(changeAgentSearchtUser(mob));
    }
  }, [mob]);

  return (
    <div className="search my-2">
      <div className="searchForm flex gap-2 align-items-center justify-content-center px-2">
        <div className="flex-grow-1">
          <span className="p-input-icon-right w-full">
            {!username || username?.length === 0 ? (
              <i className="pi pi-search" />
            ) : (
              <i
                className="pi pi-times cursor-pointer"
                onClick={() => {
                  setUsername('');
                  navigate(`/chat`);
                }}
              />
            )}
            <InputText
              type="text"
              placeholder="Search customer"
              onChange={(e) => {
                setInitialLoad(false);
                setUsername(e.target.value);
              }}
              value={username}
              className="chat-search capitalize"
            />
          </span>
        </div>
      </div>

      {err && <span>Customer not found!</span>}
    </div>
  );
};

export default Search;
